// removed by extract-text-webpack-plugin
module.exports = {"play":"src-components-legacy-SVG-__SVG-module___play","agreement":"src-components-legacy-SVG-__SVG-module___agreement","iPhoneXContainer":"src-components-legacy-SVG-__SVG-module___iPhoneXContainer","iPhoneWidthMod":"src-components-legacy-SVG-__SVG-module___iPhoneWidthMod","iPhoneXBody":"src-components-legacy-SVG-__SVG-module___iPhoneXBody","iPhoneXScreen":"src-components-legacy-SVG-__SVG-module___iPhoneXScreen"};


//////////////////
// WEBPACK FOOTER
// ./src/components-legacy/SVG/SVG.module.css
// module id = 191
// module chunks = 0